import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-linear-list-item-label',
  template: '<ng-content />',
  styleUrls: ['linear-list-item-label.component.scss'],
  host: {
    'role': 'rowheader'
  }
})
export class LinearListItemLabelComponent {
}
